import { render } from "./Sale_Refunds.vue?vue&type=template&id=880495ec"
import script from "./Sale_Refunds.vue?vue&type=script&lang=js"
export * from "./Sale_Refunds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__